module.exports = __webpack_public_path__ + "img/clock-six-thirty.62ea0774.svg";